import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import learningApiAuth from '@src/services/api/learning/token'
import { isRefreshTokenValid } from '@utils/commonUtil'

export const useLearningAuthStore = defineStore('learningAuth', () => {
  const deviceToken = ref(null)
  const pushToken = ref(null)
  const pushTokenEndpointId = ref(null)
  const accessToken = ref(null)
  const accountInfo = ref(null) // アカウント登録情報
  const tempAccessToken = ref(null) // 認証コード用

  const resetAuth = () => {
    $logger.info(
      'Reset these authentication data',
      'deviceToken', 'pushToken', 'pushTokenEndpointId', 'accessToken', 'accountInfo'
    )
    deviceToken.value = null
    pushToken.value = null
    pushTokenEndpointId.value = null
    accessToken.value = null
    accountInfo.value = null
    tempAccessToken.value = null
  }
  const login = async (body) => {
    return learningApiAuth.getToken(body).then((res) => {
      console.log('login res', res.data)
      accessToken.value = res.data.access_token
      console.log('loginlogin', accessToken.value)
      return res
    })
  }
  const updateAccessToken = (token) => {
    console.log('updateAccessToken', token)
    accessToken.value = token
  }
  const updateTempAccessToken = (token) => {
    console.log('updateTempAccessTokenげっと', token)
    tempAccessToken.value = token
  }
  const withdraw = () => {
    return learningApiAuth.withdraw().finally(() => { resetAuth() })
  }
  const fetchAccountInfo = async () => {
    // todo 会員情報取得
  }
  const userLogging = computed(() => {
    return accessToken.value !== null && isRefreshTokenValid(accessToken.value)
  })

  return {
    login,
    withdraw,
    fetchAccountInfo,
    deviceToken,
    pushToken,
    pushTokenEndpointId,
    accessToken,
    accountInfo,
    tempAccessToken,
    userLogging,
    updateAccessToken,
    updateTempAccessToken,
    resetAuth
  }
}, { persist: true })
